import { styled } from "@mui/material";

export const Spacer = styled("div")(({ theme }) => ({
  height: theme.spacing(2),
  [theme.breakpoints.up("md")]: {
    height: theme.spacing(3),
  },
}));
